<ng-container *ngIf="!keys.messageDetails; else listTemplate">
	<div class="content">
		<h1 *ngIf="keys.title">{{ keys.title }}</h1>
	</div>
	<ng-content *ngTemplateOutlet="footer"></ng-content>
</ng-container>

<ng-template #listTemplate>
	<header class="dialog-header">
		<div>
			<ng-content></ng-content>
		</div>
		<button [attr.title]="'close' | translate" [attr.aria-label]="'close' | translate" class="action" (click)="ok()">
			<i class="ico ico-close"></i>
		</button>
	</header>
	<article class="warning-container">
		<h1 *ngIf="keys.title">{{ keys.title }}</h1>
		<p class="p1">{{ keys.message }}</p>
		<div class="grouped-list" *ngIf="keys.messageDetails">
			<div class="group">
				<header class="group-header">
					<div class="details-header" (click)="toggleList()">
						<h3>
							<span>{{ keys.messageDetails.header }}</span
							><span class="counter">{{ keys.messageDetails.list.length }}</span>
						</h3>
						<stages-button-expand-collapse
							[isCollapsed]="!messageDetailsExpanded"
							[classes]="'action'"
						></stages-button-expand-collapse>
					</div>
				</header>
				<div class="details" *ngIf="messageDetailsExpanded">
					<ul class="list">
						<li class="list-item" *ngFor="let entry of keys.messageDetails.list">
							<i class="ico ico-warning warning-color"></i> {{ entry }}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</article>
	<ng-content *ngTemplateOutlet="footer"></ng-content>
</ng-template>

<ng-template #footer>
	<footer>
		<stages-buttons-bottom [removeBoundaries]="true">
			<button class="sm save" *ngIf="keys.ok" (click)="ok()" tabindex="1" [translate]="keys.ok"></button>
		</stages-buttons-bottom>
	</footer>
</ng-template>
